.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: var(--font-size-lg);
  color: var(--color-text-1);
}

.name {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semi-bold);
}

.price {
  align-items: baseline;
}
